import styleFn, {compose} from '../util'

const bgImage = styleFn({
  propName: 'bgImage',
  cssProp: 'background-image'
})

const bgPosition = styleFn({
  propName: 'bgPosition',
  cssProp: 'background-position'
})

const bgSize = styleFn({
  propName: 'bgSize',
  cssProp: 'background-size'
})

const bgRepeat = styleFn({
  propName: 'bgRepeat',
  cssProp: 'background-repeat'
})

export default compose(
  bgImage,
  bgPosition,
  bgSize,
  bgRepeat
)
